// @ts-nocheck
/* eslint-disable */
/**
 * Generated by orval 🍺
 * Do not edit manually.
 * SUREnet overig API
 * OpenAPI spec version: 1
 */
import { useQuery } from '@tanstack/vue-query';
import type {
  DataTag,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryReturnType,
} from '@tanstack/vue-query';

import { computed, toValue, unref } from 'vue';
import type { MaybeRefOrGetter } from 'vue';

import type { CollectionResultOfSUREbusinessManagementKvkKvkBedrijfDto } from '../model/collectionResultOfSUREbusinessManagementKvkKvkBedrijfDto.ts';

import type { KvkGetBedrijfParams } from '../model/kvkGetBedrijfParams.ts';

import type { MicrosoftAspNetCoreHttpHttpValidationProblemDetails } from '../model/microsoftAspNetCoreHttpHttpValidationProblemDetails.ts';

import type { MicrosoftAspNetCoreMvcProblemDetails } from '../model/microsoftAspNetCoreMvcProblemDetails.ts';

import type { Result1OfSUREbusinessManagementKvkKvkBedrijfsProfielDto } from '../model/result1OfSUREbusinessManagementKvkKvkBedrijfsProfielDto.ts';

import { customInstance } from '../../customInstance.ts';
import type { ErrorType } from '../../customInstance.ts';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

export const kvkGetBedrijf = (
  params?: MaybeRefOrGetter<KvkGetBedrijfParams>,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  params = toValue(params);

  return customInstance<CollectionResultOfSUREbusinessManagementKvkKvkBedrijfDto>(
    { url: `/api/v1/kvk/bedrijven`, method: 'GET', params, signal },
    options,
  );
};

export const getKvkGetBedrijfQueryKey = (params?: MaybeRefOrGetter<KvkGetBedrijfParams>) => {
  return ['api', 'v1', 'kvk', 'bedrijven', ...(params ? [params] : [])] as const;
};

export const getKvkGetBedrijfQueryOptions = <
  TData = Awaited<ReturnType<typeof kvkGetBedrijf>>,
  TError = ErrorType<
    MicrosoftAspNetCoreMvcProblemDetails | MicrosoftAspNetCoreHttpHttpValidationProblemDetails
  >,
>(
  params?: MaybeRefOrGetter<KvkGetBedrijfParams>,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof kvkGetBedrijf>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getKvkGetBedrijfQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof kvkGetBedrijf>>> = ({ signal }) =>
    kvkGetBedrijf(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof kvkGetBedrijf>>,
    TError,
    TData
  >;
};

export type KvkGetBedrijfQueryResult = NonNullable<Awaited<ReturnType<typeof kvkGetBedrijf>>>;
export type KvkGetBedrijfQueryError = ErrorType<
  MicrosoftAspNetCoreMvcProblemDetails | MicrosoftAspNetCoreHttpHttpValidationProblemDetails
>;

export function useKvkGetBedrijf<
  TData = Awaited<ReturnType<typeof kvkGetBedrijf>>,
  TError = ErrorType<
    MicrosoftAspNetCoreMvcProblemDetails | MicrosoftAspNetCoreHttpHttpValidationProblemDetails
  >,
>(
  params?: MaybeRefOrGetter<KvkGetBedrijfParams>,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof kvkGetBedrijf>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getKvkGetBedrijfQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

export const kvkGetBedrijfsProfiel = (
  kvknummer: MaybeRefOrGetter<string | undefined | null>,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  kvknummer = toValue(kvknummer);

  return customInstance<Result1OfSUREbusinessManagementKvkKvkBedrijfsProfielDto>(
    { url: `/api/v1/kvk/profielen/${kvknummer}`, method: 'GET', signal },
    options,
  );
};

export const getKvkGetBedrijfsProfielQueryKey = (
  kvknummer: MaybeRefOrGetter<string | undefined | null>,
) => {
  return ['api', 'v1', 'kvk', 'profielen', kvknummer] as const;
};

export const getKvkGetBedrijfsProfielQueryOptions = <
  TData = Awaited<ReturnType<typeof kvkGetBedrijfsProfiel>>,
  TError = ErrorType<
    | MicrosoftAspNetCoreMvcProblemDetails
    | MicrosoftAspNetCoreHttpHttpValidationProblemDetails
    | void
  >,
>(
  kvknummer: MaybeRefOrGetter<string | undefined | null>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof kvkGetBedrijfsProfiel>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getKvkGetBedrijfsProfielQueryKey(kvknummer);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof kvkGetBedrijfsProfiel>>> = ({ signal }) =>
    kvkGetBedrijfsProfiel(kvknummer, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: computed(() => toValue(kvknummer) !== null && toValue(kvknummer) !== undefined),
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof kvkGetBedrijfsProfiel>>, TError, TData>;
};

export type KvkGetBedrijfsProfielQueryResult = NonNullable<
  Awaited<ReturnType<typeof kvkGetBedrijfsProfiel>>
>;
export type KvkGetBedrijfsProfielQueryError = ErrorType<
  MicrosoftAspNetCoreMvcProblemDetails | MicrosoftAspNetCoreHttpHttpValidationProblemDetails | void
>;

export function useKvkGetBedrijfsProfiel<
  TData = Awaited<ReturnType<typeof kvkGetBedrijfsProfiel>>,
  TError = ErrorType<
    | MicrosoftAspNetCoreMvcProblemDetails
    | MicrosoftAspNetCoreHttpHttpValidationProblemDetails
    | void
  >,
>(
  kvknummer: MaybeRefOrGetter<string | undefined | null>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof kvkGetBedrijfsProfiel>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getKvkGetBedrijfsProfielQueryOptions(kvknummer, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}
